import {CasinoLegacyDeepLinkActionBase} from '../casino-legacy-deep-link-action-base';

export class CrossDeepLinkAction extends CasinoLegacyDeepLinkActionBase {
    async execute(): Promise<void> {
        const id = this.descriptor.actionParams.id;
        switch (id) {
            case 'poker':
                await this.services.linksNavigation.openPoker();
                break;

            case 'sport':
                await this.services.linksNavigation.openSport();
                break;
        }

        await this._executeNextAction();
    }
}
